<template>
    <modal @close="close" dialog="modal-lg" class="reservation-modal payment dark-top">
        <div slot="title">
            <h2>Payment Link</h2>
        </div>

        <div slot="body" class="bg-lighter">
            <div class="w-100 px-4 pt-4 bg-lightest">
                <div class="d-flex mb-4">
                    <div class="col-sm-6">
                        <div class="d-flex justify-content-between align-items-center">
                            <label>Amount <span class="color-6">*</span></label>

                            <div v-if="getIsLoadingCalculations" class="col-sm-3 d-flex justify-content-center">
                                <loader></loader>
                            </div>

                            <div v-else class="d-flex">
                                <input
                                    type="text"
                                    class="fs-large flex-grow-1 text-right bg-lighter glued-right input--value"
                                    v-model="linkValue"
                                    placeholder="0"
                                    v-numFloat
                                    :disabled="generatedLink[0]"
                                >
                                <div class="border-light d-flex justify-content-center glued-left fs-large py-2 px-2 currency-symbol">€</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 d-flex align-items-center">
                        <span v-if="isValueExceedingDue" class="fs-small color-6">The payment amount cannot exceed the amount due.</span>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="d-flex justify-content-between align-items-center customazed-v-select">
                        <label>Select a time to reservation expires <span class="color-6">*</span></label>

                        <div class="d-flex">
                            <input
                                type="number"
                                step=".01"
                                min="0"
                                max="999"
                                class="fs-large flex-grow-1 text-right bg-lighter glued-right"
                                v-model="timeReservationExpires"
                                style="width: 70px;"
                                placeholder="0"
                                :disabled="generatedLink[0]"
                                @input="validateExpirationInput"
                            >
                            
                            <v-select
                                class="border-light d-flex justify-content-center glued-left fs-large" style="width: 100px;"  
                                v-model="selectedTypeTime"
                                :options="optionsTypesTime"
                                label="description"
                                >
                            </v-select>
                        </div>
                    </div>
                    <div v-if="isExpirationExceedingLimit" class="fs-small color-6 mt-2">
                        Maximum value is 999. Hours: up to 999 hours (~41 days), Days: up to 999 days (~2.7 years).
                    </div>
                </div>

                <div class="col-sm-12 d-flex align-items-end mb-2 justify-content-end">
                    <div>
                        <label class="mr-3">
                            <span v-if="totalDue >= 0">
                                <span v-if="reservation.changeStatusTo == '-5' || reservation.changeStatusTo == '-6'">Value to refund</span>
                                <span v-else>Due to Pay</span>
                            </span>
                            <span v-if="totalDue < 0">Over Pay</span>
                        </label>

                        <span v-if="getReservationCreation" class="fs-large font-weight-600 pointer" @click="copyValueToInput( outstandingAmout - generatedLinkValue )" :class="{'color-3': ( outstandingAmout - generatedLinkValue ) == 0 }">{{ formatPrice(outstandingAmout - generatedLinkValue ) }} €</span>
                        <span v-else class="fs-large font-weight-600 pointer" @click="copyValueToInput(totalDue - generatedLinkValue)" :class="{'color-3': (totalDue - generatedLinkValue) == 0 }">{{ formatPrice(totalDue - generatedLinkValue ) }} €</span>

                        <label class="mx-3">
                            Total
                        </label>
                        <span class="fs-large font-weight-600 pointer" @click="copyValueToInput( formatPrice(getReservationCalculations.grandTotal) )">{{ formatPrice(getReservationCalculations.grandTotal) }} €</span>
                    </div>
                </div>

                <div class="col-sm-12 pb-2">
                    <label>Notes</label>

                    <div>
                        <input type="text" class="w-100" v-model="link.description" :disabled="generatedLink[0]" maxlength="50">
                        <span class="fs-small mt-1 d-block text-right" :class="{ 'color-6': (link.description || '').length > 50 }">{{ (link.description || '').length }}/50</span>
                    </div>

                    <div class="fs-small color-1 mt-2" v-if="!hasEmail">
                        <strong>Note:</strong> This booking has no email address.
                    </div>
                </div>

                <div v-if="this.getReservationCreation && generatedLink.length != 0" class="bg-lighter px-2 py-3 mb-3 mt-1 radius-normal" style="border: 1px solid rgb(197, 208, 222);list-style-type: disc; padding-left: 40px !important;">
                    <div class="d-flex justify-content-between align-items-center ">
                        <span class="mr-4" v-if="generatedLink[0].cancelBookingIfNotPaidAfter">
                            <strong>Expires:</strong> {{formatDateDots(generatedLink[0].cancelBookingIfNotPaidAfter)}} 
                            <strong> at </strong><span>{{formatTime(generatedLink[0].cancelBookingIfNotPaidAfter) }}</span>
                        </span>

                        <span class="mr-4" v-else>
                            <strong>Expires:</strong> n/a
                        </span>

                        <span class="mr-2"><strong>Notes:</strong> {{generatedLink[0].description ? generatedLink[0].description : 'n/a'}}</span>
                        
                        <span><strong>Amount:</strong> {{formatPrice(generatedLink[0].value)}}</span>

                        <i @click="deleteLink(generatedLink[0])" class="fa fa-times fs-large light ml-2 pointer"></i>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="!this.getReservationCreation" slot="footer">
            <button type="button" class="btn cancel widest" @click="cancel" :disabled="isSaving">Cancel</button>

            <button type="button" class="btn ok widest"
                :disabled="!link.value || link.value == 0 || isValueExceedingDue || !timeReservationExpires || isDescriptionExceedingLimit || isExpirationExceedingLimit || isSaving"
                @click="save(false)">
                <loader v-if="isSaving" size="small" />
                <template v-else>Save</template>
            </button>
        </div>
        <div v-else slot="footer">
            <button type="button" class="btn cancel widest" @click="cancel" :disabled="isSaving">Cancel</button>
            
            <button type="button" class="btn ok widest"
                :disabled="!link.value || link.value == 0 || isValueExceedingDue || !timeReservationExpires || isDescriptionExceedingLimit || isExpirationExceedingLimit || isSaving"
                @click="save(false)">
                <loader v-if="isSaving" size="small" />
                <template v-else>Save</template>
            </button>
        </div>
    </modal>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import { reservationsMixin } from '@/mixins/reservations'

    import Modal from './Modal'
    import extendedVSelect from '@/extends/vue-select'
    import TeamMemberPicker from '../TeamMemberPicker'
    import Loader from '@/tools/loaders/loader1'

export default {
        props: {
            direction:{
                default: 0,
                type: Number
            },
        },
        data() {
            return {
                optionsTypesTime : [
                    { value: 0, description: 'hours' },
                    { value: 1, description: 'day(s)' }
                ],
                selectedTypeTime: null,
                timeReservationExpires: null,
                link: {
                    bookingId : 0,
                    description : '',
                    url:'',
                    value : null, 
                    cancelBookingIfNotPaidAfter : null
                },
                
                generatedLink: [],
                clickedSave: false,
                MAX_EXPIRATION_VALUE: 999,
                isSaving: false
            }
        },
        created() {
            this.link.value = this.maxAllowedLinkValue;

            this.selectedTypeTime = this.optionsTypesTime[0];
        },
        mixins: [
            reservationsMixin
        ],
        computed: {
            ...mapGetters([
                'getReservationCreation',
                'getSelectedReservation',
                'getReservation',
                'getCountries',
                'account',
                'getReservationCalculations',
                'getIsSavingReservation',
                'getPaymentTypeListAll',
                'getIsAddingReservation',
                'getIsLoadingCalculations',
                'getPayoutReasons'
            ]),
            hasEmail() {
                return this.reservation.customer.email;
            },
            generatedLinkValue() {
                if (this.generatedLink.length) {
                    let valueOfLink = this.generatedLink[0].value;

                    return Number(valueOfLink);
                } else {
                    return Number(0);
                }
            },
            linkValue: {
                get() {
                    if (this.getReservationCreation) {
                        if (this.link.value != null) {
                            return this.link.value;
                        } else {
                            return this.outstandingAmout - this.generatedLinkValue;
                        }
                    } else {
                        if (this.link.value != null) {
                            return this.link.value;
                        } else {
                            return this.totalDue;
                        }
                    }
                },
                set(val) {
                    this.$set(this.link, 'value', val);
                }
            },
            reservation() {
                if (this.getReservationCreation) {
                    return this.getReservation;
                }
                return this.getSelectedReservation;
            },
            outstandingAmout() {
                return this.getReservationCalculations.grandTotal;
            },
            maxAllowedLinkValue() {
                const due = this.getReservationCreation ? this.outstandingAmout : this.totalDue;
                const maximum = this.reservation.paymentLinkMaximumValue;
                return maximum != null ? Math.min(due, maximum) : due;
            },
            isValueExceedingDue() {
                return parseFloat(this.linkValue) > this.maxAllowedLinkValue;
            },
            isDescriptionExceedingLimit() {
                return this.link.description.length > 50;
            },
            isExpirationExceedingLimit() {
                return this.timeReservationExpires > this.MAX_EXPIRATION_VALUE;
            },
        },
        methods: {
            ...mapActions([
                'createNewReservation',
                'closeModal',
                'addFloatingNotification',
                'unsetReservationCreation'
            ]),
            validateExpirationInput() {
                if (this.timeReservationExpires > this.MAX_EXPIRATION_VALUE) {
                    this.timeReservationExpires = this.MAX_EXPIRATION_VALUE;
                }
                if (this.timeReservationExpires < 0) {
                    this.timeReservationExpires = 0;
                }
            },
            cancel() {
                this.unsetReservationCreation();
                this.close();
            },
            close() {
                this.closeModal();
            },
            deleteLink(paymentsInMemoryItem) {
                this.generatedLink.splice(paymentsInMemoryItem);
                this.link.value = this.outstandingAmout;
                this.reservation.isToGeneratePaymentLink = false;
            },
            copyValueToInput(value){
                this.$set(this.link, 'value', value < 0? value*-1 : value);
            },
            async save() {
                if (this.isSaving) return;
                this.isSaving = true;
                // Config time of link expires
                const hoursToExpireReservation = this.timeReservationExpires;
                let typeTime = 0;

                if (this.selectedTypeTime.value == 0) {
                    typeTime = this.timeReservationExpires;
                } else {
                    typeTime = (this.timeReservationExpires) * 24;
                }   
                
                this.reservation.isToGeneratePaymentLink = true;
                
                if (!this.reservation.bookingBillingPaymentLink) {
                    this.reservation.bookingBillingPaymentLink = {};
                }

                this.reservation.bookingBillingPaymentLink.bookingId = 0;
                this.reservation.bookingBillingPaymentLink.description = this.link.description;
                this.reservation.bookingBillingPaymentLink.value = this.link.value;
                this.reservation.bookingBillingPaymentLink.cancelBookingIfNotPaidAfter = hoursToExpireReservation != 0 && hoursToExpireReservation != null ? moment().add(typeTime, 'hours').format("YYYY-MM-DD HH:mm:00") : null;

                if (!this.getReservationCreation) {
                    // ======================================================
                    // reservation EDIT mode, getReservationCreation == false
                    // target reservation = this.getSelectedReservation
                    // ======================================================
                    if (this.link.value != null && this.link.value > 0 || this.generatedLink.length != 0) {
                        this.$set(this.getSelectedReservation.updateFlags, 'paymentLink', true);
                        // Just to make sure
                        this.unsetReservationCreation();
                        this.close();

                    } else {
                        this.unsetReservationCreation();
                        this.close();
                    }
                } else {
                    // =========================================================
                    // reservation CREATION mode, getReservationCreation == true
                    // target reservation = this.getReservation
                    // =========================================================
                    if (this.getIsAddingReservation == true || this.clickedSaveAndPrint == true || this.clickedSave == true) {
                        this.$toasted.info('Already creating reservation, please wait.');
                        
                        return false;
                    }

                    this.createNewReservation({
                        supplierId: this.account.supplierId,
                        reservation: this.reservation
                    }).then(response => {
                        this.clickedSave = false;
                        if (response.status == 200) {
                            this.closeModal();
                            this.addFloatingNotification(
                                {
                                    type: -1,
                                    title: 'Ticket '+this.formatTicketNumber(response.data.id),
                                    message: response.data.customer.name+' <br>'+response.data.event.product.name,
                                    bookingId: response.data.id,
                                },
                                'info',
                                {
                                    link: '/reservations/view/'+response.data.id
                                }
                            )

                            this.$toasted.success('Reservation created successfully');
                            this.$router.push({ name: 'reservations' });
                        }
                    }).catch(err => {
                        this.clickedSave = false;
                    })
                }
            }
        },
        components: {
            Modal,
            vSelect: extendedVSelect,
            TeamMemberPicker,
            Loader,
        },
    }
</script>

<style lang="scss" scoped>
    .input--value {
        width: 70px;
    }

    .currency-symbol {
        width: 100px;
    }
</style>



// WEBPACK FOOTER //
// ReservationLink.vue?4acc6afc